var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDone(props) {
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.602 7.747c-.444 0-.887.173-1.203.512-.284.302-.423.69-.395 1.093.027.403.22.768.539 1.036l2.873 2.378c.292.24.668.376 1.055.376.044 0 .088 0 .132-.003a1.632 1.632 0 001.107-.55l7.037-8.124c.56-.645.456-1.598-.228-2.125a1.66 1.66 0 00-1.17-.332 1.628 1.628 0 00-1.08.546l-5.99 6.91L3.653 8.12c-.3-.249-.68-.373-1.051-.373z",
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.675 14c-.357 0-.7-.12-.968-.34L1.498 11.04c-.606-.498-.669-1.36-.133-1.925a1.547 1.547 0 012.07-.125l2.066 1.685 6.894-7.852c.513-.585 1.437-.668 2.066-.195.63.478.719 1.337.21 1.922l-7.863 8.947c-.25.286-.62.465-1.012.498-.04 0-.08.004-.12.004z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M5.675 14c-.357 0-.7-.12-.968-.34L1.498 11.04c-.606-.498-.669-1.36-.133-1.925a1.547 1.547 0 012.07-.125l2.066 1.685 6.894-7.852c.513-.585 1.437-.668 2.066-.195.63.478.719 1.337.21 1.922l-7.863 8.947c-.25.286-.62.465-1.012.498-.04 0-.08.004-.12.004z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.675 14c-.357 0-.7-.12-.968-.34L1.498 11.04c-.606-.498-.669-1.36-.133-1.925a1.547 1.547 0 012.07-.125l2.066 1.685 6.894-7.852c.513-.585 1.437-.668 2.066-.195.63.478.719 1.337.21 1.922l-7.863 8.947c-.25.286-.62.465-1.012.498-.04 0-.08.004-.12.004z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.87423 5.44939 -2.91456 -1.53726 10.695 5.96)"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A",
    stopOpacity: 0.75
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FBE387",
    stopOpacity: 0.69
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#FDF2C7",
    stopOpacity: 0.362
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#FFFBF0",
    stopOpacity: 0.123
  })), _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id2,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(156.856 2.651 6.7) scale(7.56323 3.04932)"
  }, _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440063",
    stopOpacity: 0.25
  })), _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 10.228,
    y1: -9.545,
    x2: 6.488,
    y2: 15.503,
    gradientUnits: "userSpaceOnUse"
  }, _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0"
  })), _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#06C102"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#17A306"
  })), _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#33740C"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366E0D"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 10.538,
    y1: -0.091,
    x2: 5.184,
    y2: 16.846,
    gradientUnits: "userSpaceOnUse"
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#90D856"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#0C0"
  })), _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#0BCD07"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#29CF18"
  })), _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#59D335"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90D856"
  })))));
}
export default SvgDone;